import { Actions, ActionTypes } from '@appStore/help/actions';
import { Help, HelpContextualInfo } from '@model';
import { HelpState } from '@enums';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: Help;
  currentHelpState: HelpState;
  selectedTab: string;
  currentContextualInfo: HelpContextualInfo
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: null,
  currentHelpState: HelpState.closed,
  selectedTab: null, 
  currentContextualInfo: null
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.HelpLoad:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.HelpLoadSuccess:
      return { ...state, loaded: true, loading: false, data: action.payload };

    case ActionTypes.HelpLoadFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.HelpSetState:
      return { ...state, currentHelpState: action.payload };

    case ActionTypes.SelectTab:
      return { ...state, selectedTab: action.payload, currentContextualInfo: null };

    case ActionTypes.HelpSetStateAndContextualInfo:
      return { ...state, 
          currentHelpState: action.payload.state, 
          currentContextualInfo: action.payload.contextualInfo
        };

    case ActionTypes.HelpClearContextualInfo:
      return { ...state, 
        currentContextualInfo: null
      };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
export const getCurrentState = (state: State) => state.currentHelpState;
export const getSelectedTab = (state: State) => state.selectedTab;
export const getCurrentContextualInfo = (state: State) => state.currentContextualInfo;
